<template>
  <div>
    <template>
      <q-btn
        icon="print"
        @click="onGenerateReportClick"
        flat
        class="margin-btn-report"
        :label="$gettext('PRINT')"
      />
    </template>
    <div class="tw-px-5">
      <div style="width: 100%" class="q-pa-sm">
        <div class="buttons-area">
          <div class="index-table">
            <situation
              :name="situationMap['ALL_ORDERS'].keys[0]"
              @click="situationAction"
            />
            <situation
              :name="situationMap['ACTIVE'].keys[0]"
              @click="situationAction"
            />
            <situation
              :name="situationMap['CANCELED'].keys[0]"
              @click="situationAction"
            />
          </div>
        </div>
      </div>
      <jt-data-table
        id="jt-composition"
        :api-mode="false"
        :data="data"
        :fields="columns"
        :is-paginated="false"
        row-buttons
        noneselect
        @action-button="actionButton"
        :class="!data && 'tw-mt-6'"
      >
        <template #header="{ props }">
          <q-tr :props="props" class="table-header">
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-td>
            <q-td></q-td>
          </q-tr>
        </template>
        <template #body="{ props }">
          <q-tr class="text-left">
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              <div v-if="col.name == 'cod'">
                <span>
                  {{ props.row["ds_numero_referencia"] }}
                </span>
              </div>
              <div v-else-if="col.name == 'vltotal'" class="flex column">
                <span class="tw-text-sm">
                  {{
                    props.row["vl_total"].toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </span>
                <span>
                  {{`${$gettext("EMISSION")} ${formatDate(props.row["dt_registro"])}`}}
                </span>
              </div>
              <div v-if="col.name == 'vloriginal'">
                <span> - </span>
              </div>
              <div v-if="col.name == 'qtdparcelas'">
                <span>
                  {{ props.row["qt_tarifas"] }}
                </span>
              </div>
              <div v-if="col.name == 'status'">
                <situation :name="props.row['id_status']" />
              </div>
              <span v-else>
                {{ col.value }}
              </span>
            </q-td>
            <q-td>
              <q-btn
                @click="
                  () => {
                    openModal(props.row);
                  }
                "
                flat
                class="btn-open-modal"
              >
                <q-icon name="mdi-eye" />
              </q-btn>
            </q-td>
          </q-tr>
        </template>
      </jt-data-table>
    </div>
    <service-request-simple-agreement-detail-modal
      :detail="true"
      :show="modalShow"
      :rowData="modalDetail.rowData"
      @input="resetModal"
    />
    <JtDocsViewer
        :src="fileSrc"
        :title="$gettext('SIMPLEE_AGREEMENT_REPORT')"
        pdf
        ref="reportModal"
      />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestController from '../../../../ServiceRequestController'
import ServiceRequestInvoiceController from '../ServiceRequestInvoiceController'
import { QBtn } from 'quasar'
import moment from 'moment'
import Situation from '../component/InvoiceSituation.vue'
import ServiceRequestSimpleAgreementDetailModal from './ServiceRequestSimpleAgreementDetailModal.vue'
import { JtDataTable, JtDocs } from 'jtech-webcomps'
import MainContentLayout from '../../../Layout/MainContentLayout.vue'
import { situationMap } from '../component/situation.config'

const { JtDocsViewer } = JtDocs

@Component({
  name: 'ServiceRequestSimpleAgreementSigre',
  components: {
    MainContentLayout,
    QBtn,
    Situation,
    ServiceRequestSimpleAgreementDetailModal,
    JtDataTable,
    JtDocsViewer
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestSimpleAgreementSigre extends Vue {
  controller = ServiceRequestController.getInstance();
  invoiceController = ServiceRequestInvoiceController.getInstance();
  data = [];
  dataAuxFilter = [];
  moment = moment;
  ALL_ORDERS = 'Todas as Ordens'
  modalDetail = {
    show: false,
    rowData: 'null'
  };

  fileSrc = null

  columns = [
    {
      name: 'cod',
      label: this.$gettext('COD'),
      align: 'center',
      value: 'cod',
      field: 'cod'
    },
    {
      name: 'vltotal',
      align: 'center',
      label: this.$gettext('AMOUNT'),
      value: 'vltotal',
      field: 'vltotal'
    },
    {
      name: 'vloriginal',
      align: 'center',
      label: this.$gettext('INSTALLMENT_AMOUNT'),
      value: 'vloriginal',
      field: 'vloriginal'
    },
    {
      name: 'qtdparcelas',
      align: 'center',
      label: this.$gettext('INVOICE_COUNT'),
      value: 'qtdparcelas',
      field: 'qtdparcelas'
    },
    {
      name: 'status',
      align: 'center',
      label: this.$gettext('SITUATION'),
      value: 'status',
      field: 'status'
    }
  ];

  async onGenerateReportClick () {
    const data = JSON.stringify(this.reportData)
    const resolveLogicResult = await this.$jt.repository.resolveLogic(
      'simpleReportAgreement.simpleReportAgreement',
      { data, relFormatoRelatorio: 1, relFormaGeracao: 1 }
    )
    await this.__whenGenerationFormatIsOnline(resolveLogicResult)
  }

  get reportData () {
    return this.data.map(row => {
      return {
        code: row.ds_numero_referencia,
        negotiationDate: this.moment(row.dt_registro).format('DD/MM/YYYY'),
        negotiationType: row.id_tipo_acordo == 'A' ? this.$gettext('SIMPLE_AGREEMENT') : this.$gettext('SIMPLE_INSTALLMENT_PAYMENT'),
        installmentQuantity: row.qt_parcelas,
        status: row.id_status == 'A' ? this.$gettext('ACTIVE') : this.$gettext('CANCELLED'),
        paidAmount: String(this.amountPaid(row.parcelas_acordo_simples)),
        amountToPaid: String(row.vl_total),
        total: String(row.vl_total),
        advisoryType: row.ds_assessoria,
        parcelaAcordoSimples: this.formatParcelMessages(row.parcelas_acordo_simples)
      }
    })
  }

  getParcelMessage (parcela) {
    const formattedDate = this.moment(parcela.dt_vencto).format('DD/MM/YYYY')
    const formattedCurrency = parcela.vl_original.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    const statusText = this.$gettext(parcela.ds_status_parcela)

    return `${parcela.nr_parcela}-${this.$gettext('MATURITY')}: ${formattedDate}-${this.$gettext('VALUE')}: ${formattedCurrency}-${this.$gettext('STATUS')}: ${statusText}`
  }

  formatParcelMessages (parcelas) {
    return parcelas.map(this.getParcelMessage).join('\n')
  }

  amountPaid (installmentsSimpleAgreement) {
    return this.sumAtributeArray(installmentsSimpleAgreement, 'vl_pago')
  }

  amountToPaid (totalValue, parcelasAcordoSimples) {
    return totalValue - this.amountPaid(parcelasAcordoSimples)
  }

  sumAtributeArray (arr, atribute) {
    arr = arr || []
    return arr.reduce((acumulador, obj) => {
      return acumulador + obj[atribute]
    }, 0)
  }

  async __whenGenerationFormatIsOnline ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        'pdf',
        '',
        'application/pdf'
      )

      this.fileSrc = URL.createObjectURL(result)
      this.$nextTick(() => {
        this.$refs.reportModal.show()
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  situationAction (name) {
    this.data = this.dataAuxFilter
    if (name != this.ALL_ORDERS) {
      this.data = this.data.filter((agreement) => agreement.id_status == name)
    }
  }

  get situationMap () {
    return situationMap
  }

  get modalShow () {
    return this.modalDetail.show
  }

  resetModal () {
    this.modalDetail.rowData = null
    this.modalDetail.show = false
  }

  openModal (row) {
    this.modalDetail.rowData = row
    this.modalDetail.show = true
  }

  async mounted () {
    this.data = await this.invoiceController.simpleAgreementsByUnid()
    this.data = this.data.map((row) => {
      return { ...row, selected: false }
    })
    this.dataAuxFilter = this.data
  }

  get paidOff () {
    return this.getTotalInformation(this.$gettext('PAID_OFF'))
  }

  get pending () {
    return this.getTotalInformation(this.$gettext('OPEN_SUPPORT_CALL'))
  }

  get inDelay () {
    return this.getTotalInformation(this.$gettext('OVERDUE'))
  }

  get negotiated () {
    return this.getTotalInformation(this.$gettext('NEGOTIATED'))
  }

  formatDate (date) {
    return this.moment(date).format('DD/MM/YYYY')
  }
}
export default ServiceRequestSimpleAgreementSigre
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
.table-header {
  background-color: #f1f1f1;
  margin: 30px;
}

.cell-values {
  display: flex;
  flex-direction: column;
}

.colapse-area {
  background-color: #5898aa;
  display: grid;
  grid-template-columns: 32% 32% 32% 4%;
}

.box-buttom {
  grid-column-start: 4;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 35px;
}

.colapse {
  color: #fff;
  padding: 8px 20px;
}

.row-paint-colapse {
  background-color: #f1f1f1;
}

.index {
  border-radius: 25px;
  padding: 2px 10px;
  max-height: 25px;
}

.buttons-area {
  height: 35px;
  display: flex;
}

.index-table {
  width: 50%;
  display: flex;
  align-items: center;
  gap: 15px;
}

.rigth-buttons {
  width: 50%;
  display: flex;
  justify-content: right;
}

.sub-teble-btn {
  border: none;
  background-color: #fff;
  font-size: 18px !important;
  margin-left: 15px;
}

.top-area {
  background-color: #f1f1f1;
  display: flex;
  justify-content: space-around;
  padding: 17px 0;
}

.small-span {
  font-weight: 300;
}

.block-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.margin-btn-report {
  margin: 10px 0px 10px 20px;
}

.btn-open-modal {
  color: #444
}

</style>
